// extracted by mini-css-extract-plugin
module.exports = {"container":"s4NWC8a6","body":"ypIwRPcg","secondaryInfo":"rbgZB92o","keywordSearchTerm":"IvgNmOIJ"};